import React from 'react'
import VendorSidebar from '../Components/vendorsidebar'
import VendorHeader from '../Components/vendorheader'
import { Outlet } from 'react-router-dom'

function VendorLayout() {
  return (
    <div className="flex h-screen">
    <VendorSidebar role="vendor" />

    <div className="flex-1 flex flex-col">
        <VendorHeader role="vendor" />

        <main className="p-4 mt-10 lg:mt-0 bg-[#FFFFFF] lg:pl-[265px] pl-0 transition-all duration-300">
            <Outlet />
        </main>
    </div>
</div>  )
}

export default VendorLayout